import axios from "axios";

/**
 *  @example
 * {"deliveryDate":"2022-08-24",
 *
 *	// als pickup:
 *	"pickup_point": ID gekozen ophaalplek
 *	"pickup":"1",
 *	"open": "krijg je van /pickuppoints",
 *	"close": "krijg je van /pickuppoints",
 *
 *	// als delivery:
 *	"delivery": "1",
 *	"from":"krijg je van /delivery",
 *	"until":"krijg je van /delivery",
 *	"delivery_costs": "krijg je van delivery",
 *	"location":"1434",
 *
 *	//zakelijk
 * 	"location":"1434"
 *	}
 */
export const placeOrder = (body, pay_online = false) => {
	return axios
		.post("/place_order", body)
		.then((response) => {
			alert(response.data.message);
			if (response.data.code == "200" && pay_online) {
				console.log("HIER");
				console.dir(response);

				//window.location.replace(response.data.checkout_redirect_url); //TODO:CHECK DEZE API
			} else {
				window.location.replace("/");
			}
		})
		.catch((err) => {
			console.log(
				"[placeOrder.actions.js] placeOrder || Could not place the order. Try again later."
			);
		});
};

export const fetchBalance = (userId, setBalance) => {
	return axios
		.post("/balance", { user_id: userId })
		.then((response) => {
			if (response.data.code == "200") {
				setBalance(response.data.data.balance);
			}
		})
		.catch((err) => {
			console.log(
				"[fetchBalance.actions.js] fetchBalance || Could not fetch balance. Try again later."
			);
		});
};

export const fetch_discount_info = (
	code,
	marketplace_id,
	user_id,
	setDiscountInfo,
	setDiscountMessage
) => {
	return axios
		.post("/discount_code", {
			code: code,
			marketplace: marketplace_id,
			user_id: user_id,
		})
		.then((response) => {
			if (response.data.code == "200") {
				let responseBody = response.data.data;
				responseBody.kortingscode = code;
				setDiscountInfo(responseBody);
			} else {
				setDiscountInfo({
					//put it back to default
					kortingscode: "AAAAA",
					value: 0,
					type: "amount",
					shipping: false,
				});
			}
			setDiscountMessage(response.data.message);
		})
		.catch((err) => {
			console.log(
				"[fetchBalance.actions.js] fetch_discount_info || Could not fetch discount information. Try again later."
			);
		});
};

export default placeOrder;
